import React, { useEffect } from 'react'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { Navigate, Route, Routes } from 'react-router-dom'

import Home from './user/Pages/Home'
import About from './user/Pages/About'
import Services from './user/Pages/Services';
import PageNotFound from './user/Pages/PageNotFound'
import Contact from './user/Pages/Contact';
import Portfolio from './user/Pages/Portfolio'
import Blog from './user/Pages/Blog';
import Software from './user/Pages/Software';
import UIUX from './user/Pages/uiux';
import Login from './admin/Pages/Login';
import AdminRoute from './Routes/AdminRoute';
import UserRoute from './Routes/UserRoute';
// import Sinup from './admin/Pages/Sinup'; // REMOVED
import ForgotPassword from './admin/Pages/ForgotPassword';
import ConfirmOTP from './admin/Pages/ConfirmOTP';
import ResetPassword from './admin/Pages/ResetPassword';
import LoginRoute from './Routes/LoginRoute';
import AboutAdmin from './admin/Pages/AboutAdmin';
import ManageServices from './admin/Pages/ManageServices';
import TestimonialAdmin from './admin/Pages/TestimonialAdmin';
import ManageBlogs from './admin/Pages/ManageBlogs';
import CareerPage from './user/Pages/Career';
import HRInternJobPage from './user/Pages/HrIntern';
import BlogDetailPage from './user/Pages/BlogDetail';
// import BlogDetailPageNew from './user/Pages/BlogDetail_2';
import DigitalMarketing from './user/Pages/digital';
import VideoEditing from './user/Pages/video';
import SocialMediaMarketing from './user/Pages/social';
import SEOSMOServices from './user/Pages/seo';
import MobileDevelopment from './user/Pages/mobile';
import SeniorSoftwareEngineer from './user/Pages/Engineer';
import UIUXDesigner from './user/Pages/Designer';
import TermsAndConditions from './user/Component/Terms';
import PrivacyPolicy from './user/Component/Privacy';
import TestimonialsPage from './user/Pages/Testimonial';

import Dashboard from './admin/Pages/Dashboard';
// import ManageNavigation from './admin/Pages/ManageNavigation'; // REMOVED
import ManageTeam from './admin/Pages/ManageTeam';
import ManageContact from './admin/Pages/ManageContact';
import ManagePortfolio from './admin/Pages/ManagePortfolio';
import ManageCareer from './admin/Pages/ManageCareer';
// import SampleAdminAboutPage from './admin/Pages/SampleAdminAboutPage'; // REMOVED

const Mainpage = () => {

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Routes>

        {/* ---------------- USER ROUTES ---------------- */}
        <Route path="/" element={<UserRoute Component={Home} />} />
        <Route path="/about" element={<UserRoute Component={About} />} />
        <Route path="/services" element={<UserRoute Component={Services} />} />
        <Route path="/software" element={<UserRoute Component={Software} />} />
        <Route path="/uiux" element={<UserRoute Component={UIUX} />} />
        <Route path="/digital" element={<UserRoute Component={DigitalMarketing} />} />
        <Route path="/video" element={<UserRoute Component={VideoEditing} />} />
        <Route path="/social" element={<UserRoute Component={SocialMediaMarketing} />} />
        <Route path="/seo" element={<UserRoute Component={SEOSMOServices} />} />
        <Route path="/mobile" element={<UserRoute Component={MobileDevelopment} />} />
        <Route path="/testimonial" element={<UserRoute Component={TestimonialsPage} />} />

        <Route path="/portfolio" element={<UserRoute Component={Portfolio} />} />
        <Route path="/careerpage" element={<UserRoute Component={CareerPage} />} />
        <Route path="/engineer" element={<UserRoute Component={SeniorSoftwareEngineer} />} />
        <Route path="/designer" element={<UserRoute Component={UIUXDesigner} />} />

        {/* BLOG LIST PAGE */}
        <Route path="/blog" element={<UserRoute Component={Blog} />} />

        {/* ⭐ DYNAMIC BLOG DETAIL ROUTE (NEW) */}
        <Route path="/blog/:slug" element={<UserRoute Component={BlogDetailPage} />} />

        <Route path="/contact" element={<UserRoute Component={Contact} />} />
        <Route path="/hrintern" element={<UserRoute Component={HRInternJobPage} />} />

        {/* OLD BLOG ROUTES (OPTIONAL) */}
        <Route path="/BlogDetail_1" element={<UserRoute Component={BlogDetailPage} />} />
        {/* <Route path="/BlogDetail_2" element={<UserRoute Component={BlogDetailPageNew} />} /> */}

        <Route path="/terms" element={<UserRoute Component={TermsAndConditions} />} />
        <Route path="/privacy" element={<UserRoute Component={PrivacyPolicy} />} />



        {/* ---------------- ADMIN ROUTES ---------------- */}
        <Route path="/dashboard" element={<AdminRoute Component={Dashboard} />} />
        {/* <Route path="/managenavigation" element={<AdminRoute Component={ManageNavigation} />} /> */}
        <Route path="/manageteam" element={<AdminRoute Component={ManageTeam} />} />
        <Route path="/managecontact" element={<AdminRoute Component={ManageContact} />} />
        <Route path="/manageportfolio" element={<AdminRoute Component={ManagePortfolio} />} />
        {/* <Route path="/manageabout" element={<AdminRoute Component={SampleAdminAboutPage} />} /> */}
        <Route path="/managecareer" element={<AdminRoute Component={ManageCareer} />} />

        {/* Janvi Work */}
        <Route path="/aboutadmin" element={<AdminRoute Component={AboutAdmin} />} />
        {/* Renamed /ManageAdmin to /ServicesAdmin to match Sidebar */}
        <Route path="/ServicesAdmin" element={<AdminRoute Component={ManageServices} />} />
        <Route path="/manageblogs" element={<AdminRoute Component={ManageBlogs} />} />
        <Route path="/testimonialadmin" element={<AdminRoute Component={TestimonialAdmin} />} />


        {/* ---------------- LOGIN ROUTES ---------------- */}
        <Route path="/login" element={<LoginRoute Component={Login} />} />
        {/* <Route path="/signup" element={<LoginRoute Component={Sinup} />} /> */}
        <Route path="/forgotpassword" element={<LoginRoute Component={ForgotPassword} />} />
        <Route path="/confirmOTP" element={<LoginRoute Component={ConfirmOTP} />} />
        <Route path="/resetpassword" element={<LoginRoute Component={ResetPassword} />} />


        {/* 404 PAGE */}
        <Route path="/*" element={<PageNotFound />} />

      </Routes>
    </>
  )
}

export default Mainpage;
